import React, { useState, useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"

import Header from "./Header"
import Footer from "./Footer"
import Title from './Title'

const Layout = () => {
	const location = useLocation()
	const [animationKey, setAnimationKey] = useState(Date.now())

	useEffect(() => {
		setAnimationKey(Date.now())

		// Only scroll to the top if there is no hash in the URL
		if (!location.hash) {
			setTimeout(() => {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				})
			}, 100)
		}
	}, [location])

	return (
		<>
			<Title />
			<Header />
			<div key={animationKey} className="animate-fadeIn w-full">
				<Outlet />
			</div>
			<Footer />
		</>
	)
}

export default Layout